import { defaultAbiCoder, keccak256, arrayify } from 'utils/ethersImport'
export function hashData(dataTypes: any, dataValues: any) {
  const bytes = defaultAbiCoder.encode(dataTypes, dataValues)
  const hash = keccak256(arrayify(bytes))

  return hash
}

export function hashString(string: string) {
  return hashData(['string'], [string])
}
